<template>
	<div class="ao-radios">
		<v-text-field
			v-if="isSearch"
			v-model="query"
			clearable
			color="primary"
			variant="underlined"
			placeholder="Поиск"
			class="text-field-font-x-small customize-input-icons-small mb-3"
			density="compact"
			clear-icon="mdi-close"
			hide-details
		/>
		<div
			v-if="inputTitle"
			class="ao-h4 mb-1"
		>
			{{ inputTitle }}
		</div>
		<div :class="{ 'd-flex flex-wrap': horizontal }">
			<ao-radio-btn
				v-for="item in sortedItems"
				:key="getKey(item)"
				class="mb-1"
				:class="{ 'mr-4': horizontal }"
				:value="getKey(item)"
				:label="getTitle(item)"
				:checked="modelValue === getKey(item)"
				density="compact"
				@update:modelValue="update($event)"
			/>
		</div>
	</div>
</template>

<script>
import { getAlternateKeyboardLayout } from '@/helpers/stringHelper'

export default {
	name: 'AoRadios',

	props: {
		modelValue: {
			type: [String, Number, Boolean],
		},
		items: {
			type: Array,
		},
		itemTitle: {
			type: String,
		},
		itemValue: {
			type: String,
		},
		horizontal: {
			type: Boolean,
			default: false,
		},
		returnObject: Boolean,
		isSearch: Boolean,
		inputTitle: {
			type: String,
			default: null,
		},
		isSorted: {
			type: Boolean,
			default: true,
		},
		sortCompareCallback: {
			type: Function,
			default: null,
		},
	},

	emits: ['update:modelValue'],

	data: () => ({
		query: '',
	}),

	computed: {
		filteredItems() {
			if (!this.query) {
				return this.items
			}

			return this.items.filter((item) => {
				let isCurrentKeyboardLayoutResult = this.getTitle(item)
					.toLowerCase()
					.includes(this.query.toLowerCase())
				if (isCurrentKeyboardLayoutResult) {
					return true
				} else {
					return this.getTitle(item)
						.toLowerCase()
						.includes(getAlternateKeyboardLayout(this.query).toLowerCase())
				}
			})
		},
		sortedItems() {
			let sortedItems = [...this.filteredItems]
			if (this.isSorted) {
				const compareCallback = this.sortCompareCallback || ((a, b) => {
					if (typeof a === 'object' && typeof b === 'object') {
						if (a[this.itemTitle] === b[this.itemTitle]) return 0
						return a[this.itemTitle] > b[this.itemTitle] ? 1 : -1
					} else {
						if (a === b) return 0
						return a > b ? 1 : -1
					}
				})
				sortedItems.sort(compareCallback)
			}

			return sortedItems
		},
	},

	created() {},

	methods: {
		itemIsPrimitive(item) {
			return ['string', 'number', 'bigint', 'undefined', 'boolean', 'symbol', 'null'].includes(item)
		},

		getKey(item) {
			return item.hasOwnProperty(this.itemValue) ? item[this.itemValue] : item
		},

		getTitle(item) {
			return item[this.itemTitle] ? item[this.itemTitle] : item
		},

		update(item) {
			this.$emit('update:modelValue', item)
		},
	},
}
</script>

<style lang="scss">
.ao-radios {
	width: 100%;
}
</style>
